/** Display unit without "u" before number: e.g. "u1" / "UNIT 1 - Prepare" → "1 - Prepare". */
export function formatUnitDisplayTitle(unit: { id: string; title: string }): string {
  const num = unit.id.replace(/^u(\d+)$/i, "$1");
  const rest = unit.title.replace(/^unit\s*u?\d+\s*[-–:.]?\s*/i, "").trim();
  return rest ? `${num} - ${rest}` : num || unit.title;
}
